import Rule from './rule';

export default class DefaultRule extends Rule {
  constructor(ruleText, attribute,active) {
    super(ruleText, attribute,active);
    this.ruleType = 'DEFAULT';
    this.compile(ruleText);
  }

  compile(text) {
    const rule = text.replace(/^\s?default/i, '');
    this.args = [rule.trim()];
  }

  run(input, headers, resolve) {
    const arg = headers.includes(this.args[0]) ? resolve(this.args[0]) : this.args[0];
    return (!input) ? arg : input;
  }

  validate() {
    return this.args.length === 1 && this.args[0] !== '';
  }
}
